import { cx } from "@suse-o11y/class-variance";
import React, { type FC } from "react";

export interface FullCenterViewLayoutProps {
	className?: string;
	css?: never;
	tw?: never;
	header: React.ReactNode;
	content: React.ReactNode;
	image?: React.ReactNode;
	button?: React.ReactNode;
	noShadow?: boolean;
}

export const FullCenterViewLayout: FC<FullCenterViewLayoutProps> = ({
	className,
	header,
	content,
	image,
	button,
	noShadow,
	...props
}: FullCenterViewLayoutProps) => (
	<div className="flex h-full w-full grow items-center justify-center xs:text-center">
		<div
			{...props}
			className={cx("flex h-full w-full flex-col items-center justify-center", !noShadow && "shadow-sm", className)}
		>
			<header className="mb-4 font-medium text-3xl text-primary-600" data-testid="full-center-view-layout-header">
				{header}
			</header>
			<div
				className="mx-6 mb-12 max-w-[700px] text-15 text-grey-800 leading-[170%]"
				data-testid="full-center-view-layout-content"
			>
				{content}
			</div>
			{image}
			<div className={image ? "mt-12" : undefined}>{button}</div>
		</div>
	</div>
);
